export const FORM_TYPE = ["CHEM", "MIN"];
export const APP_LANG = ["UZ", "RU"];
